import React from 'react'
import styled from 'styled-components'
import { Draggable, Droppable } from 'react-beautiful-dnd'

const Container = styled.div`
    flex: 2;
    border: solid;
    border-color: darkgrey;
    border-radius: .5em;
    height: 100%;
    padding: 10px;
    overflow: scroll;
`

const PartsList = styled.div`
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    flex-direction:row;
`

const Title = styled.h2`
    display: flex;
    justify-content: center;
`

const SubTitle = styled.h4`
    display: flex;
    justify-content: center;
`


// const Element = styled.div`
// width: 100px;
// display: flex;
// border: solid darkgrey;
// border-radius: .5em;
// margin: .5em;
// padding:.5em;
// `

const Element = styled.div`
    // height: 100px;
    width: 100px;
    margin: .5em;
    border: solid darkgrey;
    border-radius: .5em;
    background: white;
    border-radius: .5em;
    display: flex;
    justify-content:center;
    align-items: center;    
`

const PartPicker = ({ stages = [], outputs=[], inputs=[] }) =>
    <Container>
        <Title>Parts Library</Title>

        <SubTitle>Stages</SubTitle>
        <hr />
        <Droppable droppableId='stages-list' isDropDisabled={true}>
            {(provided) => (<PartsList ref={provided.innerRef} {...provided.droppableProps}>
                {stages.map((s, i) => (
                    <Draggable key={s.name} draggableId={`drop-stage-${s.name}`} index={i}>
                        {(provided) => (<Element ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>{s.name}</Element>)}
                    </Draggable>
                ))}
            </PartsList>)}
        </Droppable>
        <SubTitle>Inputs</SubTitle>
        <hr />
        <Droppable droppableId='inputs-list' isDropDisabled={true}>
            {(provided) => (<PartsList ref={provided.innerRef} {...provided.droppableProps}>
                {inputs.map((s, i) => (
                    <Draggable key={s.name} draggableId={`drop-input-${s.name}`} index={i}>
                        {(provided) => (<Element ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>{s.name}</Element>)}
                    </Draggable>
                ))}
            </PartsList>)}
        </Droppable>
        <SubTitle>Outputs</SubTitle>
        <hr />
        <Droppable droppableId='outputs-list' isDropDisabled={true}>
            {(provided) => (<PartsList ref={provided.innerRef} {...provided.droppableProps}>
                {outputs.map((s, i) => (
                    <Draggable key={s.name} draggableId={`drop-output-${s.name}`} index={i}>
                        {(provided) => (<Element ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>{s.name}</Element>)}
                    </Draggable>
                ))}
            </PartsList>)}
        </Droppable>
    </Container>

export default PartPicker;